
export default [
  {
    name: `intro-video`,
    label: ``,
    src: require(`@/assets/intro/intro-tw.mp4`),
  },
];
